import curry from 'ramda/src/curry';
import map from 'ramda/src/map';
import prop from 'ramda/src/prop';

export const createPropMap = curry( ( list, propName ) => map( prop( propName ), list ) );

/**
 * Extracts only the changes between two states given a primary key. This handles nested objects and arrays.
 * @param primaryKey - String can be a nested key separated by dots
 * @param prevState - Array of objects
 * @param nextState - Array of objects
 * @returns {*}
 */
export function getChangesBy ( primaryKey, prevState, nextState ) {
    const getNestedValue = ( obj, key ) => key.split( '.' ).reduce( ( o, k ) => (o || {})[k], obj );

    const findObjectByKey = ( array, key, value ) => array.find( obj => getNestedValue( obj, key ) === value );

    const compareObjects = ( obj1, obj2 ) => {
        return Object.keys( obj2 ).reduce( ( changes, key ) => {
            if ( obj1[key] === undefined || obj1[key] !== obj2[key] ) {
                if ( typeof obj2[key] === 'object' && !Array.isArray( obj2[key] ) ) {
                    const nestedChanges = compareObjects( obj1[key] || {}, obj2[key] );
                    if ( Object.keys( nestedChanges ).length ) {
                        if ( obj2[key].id !== undefined ) {
                            nestedChanges.id = obj2[key].id;
                        }
                        changes[key] = nestedChanges;
                    }
                }
                else if ( Array.isArray( obj2[key] ) ) {
                    const arrayChanges = obj2[key].reduce( ( arr, item ) => {
                        const objInArray = findObjectByKey( obj1[key] || [],
                            primaryKey.split( '.' ).pop(),
                            getNestedValue( item, primaryKey.split( '.' ).pop() ) );
                        const itemChanges = compareObjects( objInArray || {}, item );
                        if ( Object.keys( itemChanges ).length ) {
                            if ( item.id !== undefined ) {
                                itemChanges.id = item.id;
                            }
                            arr.push( itemChanges );
                        }
                        return arr;
                    }, [] );
                    if ( arrayChanges.length ) {
                        changes[key] = arrayChanges;
                    }
                }
                else {
                    changes[key] = obj2[key];
                }
            }
            return changes;
        }, {} );
    };

    const extractPrimaryKey = ( obj ) => ({[primaryKey.split( '.' ).pop()]: getNestedValue( obj, primaryKey )});

    return nextState.reduce( ( result, nextObj ) => {
        const prevObj = findObjectByKey( prevState, primaryKey, getNestedValue( nextObj, primaryKey ) );
        const changes = prevObj ? compareObjects( prevObj, nextObj ) : nextObj;
        if ( Object.keys( changes ).length ) {
            changes[primaryKey.split( '.' )[0]] = extractPrimaryKey( nextObj );
            result.push( changes );
        }
        return result;
    }, [] );
}
